module.exports = __webpack_public_path__ + "static/media/strip-penguin-desk.8ae1619b.svg";